import React from 'react';

function NotFound() {
    return ( 
        <>
            <h1>
                Sorry, we can't find the page You are trying to reach...
            </h1>
        </>
     );
}

export default NotFound;
